import React, { PureComponent, Component } from 'react';

class ArchivoValido extends Component {
    constructor(props) {
        super(props)
        this.state = {
            CantidadDiasHabilesReproceso: props.data.proceso.CantidadDiasHabilesReproceso
        };
    }

    onChange(event) {
        const { value, dataset } = event.target;
        const regExp = new RegExp(dataset.validation);

        if ((regExp.test(value) || value.replace(/\s/g, "", "") == "")) {
            let newState = {
                [dataset.code]: value
            }
            this.setState(newState);
            this.props.changeInput(dataset.code, value);
       }
    }

    onBlur(event) {
        const { value, dataset } = event.target;
            
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            CantidadDiasHabilesReproceso: nextProps.data.proceso.CantidadDiasHabilesReproceso
        });
    }

    render() {

        const {data} = this.props;

        return (
            <div className="row top-separator-xs">
                <div style={{marginLeft:"15px"}} className="form-group bottom-separator-xs">
                    <div className="col-md-12 no-padding-left">
                        <label className="label-primary">{"Plazo Máximo de reproceso (a partir de la primera ejecución)"}</label>
                    </div>
                </div>
                <div className="row">
                    <div style={{marginLeft:"15px"}} className="col-xs-1">
                        <input className="form-control form-control-tarjetas input-Short"
                            maxLength={3}
                            value={this.state.CantidadDiasHabilesReproceso}
                            data-code="CantidadDiasHabilesReproceso"
                            data-validation="^([0-9]?\d|100)$"
                            onChange={this.onChange.bind(this)}
                            //onBlur={this.onBlur.bind(this)}
                        />
                    </div>

                    <div style={{marginLeft:"-45px"}} className="col-xs-3">
                        <label className="lbl-radio label-secondary">{"días hábiles"}</label>
                    </div>

                    <div className="col-xs-8">
                    </div>                  
                    
                </div>

                {!data.ERROR_PROCESS["seleccionoPlazoMaximo"] && 
                            <label className="error">{"Completar Plazo máximo de reproceso (a partir de la primera ejecución) con un número entero mayor a cero."}</label>}
            </div>
        )
    }
};

export default ArchivoValido;